import "./page-crop-monitoring-old.scss";
import "../../js/core";
import "../../../assets/src/eos/js/video-youtube-iframe";
import "../../components/site-elements/sliders/slider-card-blog/slider-card-blog";
import "../../components/site-elements/other-blocks/collapse-content-list/collapse-content-list";
import { SwiperInit } from "../../components/site-elements/other-blocks/swiper-tabs/swiper-tabs";

SwiperInit("swiper-1");

function ExpandListItem() {
  $(".card-quote").each(function (index) {
    var $textBlock = $(this).find(".body > .content").height();
    var $contentBlock = $(this).find(".body").height();

    if ($textBlock > $contentBlock) {
      $(this).addClass("show-btn");
    } else {
      if (!$(this).hasClass("is-active")) {
        $(this).removeClass("show-btn");
      }
    }
  });
}

// Sliders
$(function () {
  import(
    /* webpackChunkName: "chunk.owl-carousel" */ "owl.carousel/src/js/owl.carousel"
  ).then(() => {
    import(
      /* webpackChunkName: "chunk.owl-carousel-navigation" */ "owl.carousel/src/js/owl.navigation"
    ).then(() => {
      $(".slider-card-blog").owlCarousel({
        responsive: {
          0: {
            items: 1,
          },
          768: {
            items: 2,
          },
          992: {
            items: 3,
          },
        },
        loop: false,
        nav: true,
        dots: false,
        slideBy: 1,
        margin: 20,
        smartSpeed: 200,
      });

      $(".slider-card-membership").owlCarousel({
        responsive: {
          0: {
            items: 1,
          },
          568: {
            items: 2,
          },
          1024: {
            items: 3,
          },
        },
        nav: true,
        dots: false,
        dotsEach: false,
        margin: 20,
        smartSpeed: 200,
      });

      $(".slider-card-quote").owlCarousel({
        responsive: {
          0: {
            items: 1,
            dots: false,
          },
          568: {
            items: 1,
            dots: true,
          },
          992: {
            items: 2,
            dots: true,
          },
        },
        slideBy: 1,
        dots: true,
        dotsEach: true,
        nav: true,
        loop: false,
        margin: 24,
        autoHeight: true,
        mouseDrag: false,
        smartSpeed: 200,
      });

      $(".js-card-partners").owlCarousel({
        responsive: {
          0: {
            items: 1,
          },
          375: {
            items: 2,
          },
          480: {
            items: 4,
          },
          768: {
            items: 5,
          },
          1024: {
            items: 6,
          },
          1280: {
            items: 7,
          },
        },
        slideBy: 1,
        dots: false,
        nav: true,
        loop: false,
        margin: 24,
        smartSpeed: 200,
      });

      $(".owl-carousel").each(function (index) {
        $(this)
          .find(".owl-nav, .owl-dots")
          .wrapAll("<div class='owl-controls'></div>");
      });

      ExpandListItem();

      $(".slider-card-quote").on("resized.owl.carousel", function (event) {
        ExpandListItem();
      });

      $(".slider-card-quote .card .btn-link").on("click", function () {
        $(this).parents(".card").toggleClass("is-active");
      });
    });
  });
});
